import React from "react";
import { IconButton, Tooltip } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import DescriptionIcon from "@mui/icons-material/Description";
import AssignmentIcon from "@mui/icons-material/Assignment";
import { Agents } from "../../types/master";
import { useNavigate } from "react-router-dom";
import styles from "./header.module.css";

type HeaderProps = {
  userName?: string;
  isSidebarOpen?: () => void;
  onClickHelp?: () => void;
  onClickLogout?: () => void;
  currentAgent?: Agents;
};

const Header = ({ onClickHelp, isSidebarOpen, currentAgent }: HeaderProps) => {
  const navigate = useNavigate();

  const handleReadmeDownload = () => {
    try {
      if (!currentAgent?.agent_readme_path) {
        console.warn("No readme path available for this agent");
        return;
      }

      // Construct full blob URL with base URL and SAS token (same pattern as PromptModal)
      const downloadUrl = `${import.meta.env.VITE_TEMPLATE_BLOB_URL}/readme-templates/${currentAgent.agent_readme_path}?${import.meta.env.VITE_TEMPLATE_G42_FILES}`;
      const fileName =
        currentAgent.agent_readme_path.split("/").pop() || "Agent-ReadMe.pdf";

      const link = document.createElement("a");
      link.href = downloadUrl;
      link.target = "_blank";
      link.download = decodeURIComponent(fileName);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error("Error downloading readme file:", error);
    }
  };

  return (
    <div className={styles.header}>
      <div className={styles.leftSection}>
        <IconButton className={styles.menuButton} onClick={isSidebarOpen}>
          <MenuIcon />
        </IconButton>
        {/* <img src="/images/g42-logo.png" alt="G42 Logo" className={styles.logo} /> */}
      </div>
      <div className={styles.rightSection}>
        {currentAgent?.id === 26 && (
          <Tooltip title="View Procurement Dashboard" arrow>
            <IconButton
              className={styles.dashboardButton}
              onClick={() => navigate("/procurement-dashboard/contracts-management")}
              aria-label="Go to Procurement Dashboard"
            >
              <AssignmentIcon fontSize="small" className={styles.dashboardIcon} />
              <span>Dashboard</span>
            </IconButton>
          </Tooltip>
        )}
        {currentAgent?.agent_readme_path && (
          <Tooltip title='Click to download "Read Me" file for the agent' arrow>
            <IconButton
              className={styles.readmeButton}
              onClick={handleReadmeDownload}
              aria-label="Download Read Me file"
            >
              <DescriptionIcon fontSize="small" className={styles.readmeIcon} />
              <span>Read Me</span>
            </IconButton>
          </Tooltip>
        )}
      </div>
    </div>
  );
};

export default Header;
